import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { ProjectSummary, ProjectTypeSummary, ProjectChart } from './project.model';

const axios = useAxios();

export interface ProjectRegionService {
  GetSummary: (fiscalYearId: number) => Promise<AxiosResponse<ProjectSummary>>;
  GetMinisterSummary: (fiscalYearId: number, ministerId: number) => Promise<AxiosResponse<ProjectSummary>>;
  GetRegionSummary: (fiscalYearId: number, regionId: number) => Promise<AxiosResponse<ProjectSummary>>;
  GetProvinceSummary: (fiscalYearId: number, provinceId: number) => Promise<AxiosResponse<ProjectSummary>>;
  GetTypeSummary: (fiscalYearId: number) => Promise<AxiosResponse<ProjectTypeSummary[]>>;
  GetMinisterTypeSummary: (fiscalYearId: number, ministerId: number) => Promise<AxiosResponse<ProjectTypeSummary[]>>;
  GetRegionTypeSummary: (fiscalYearId: number, regionId: number) => Promise<AxiosResponse<ProjectTypeSummary[]>>;
  GetProvinceTypeSummary: (fiscalYearId: number, provinceId: number) => Promise<AxiosResponse<ProjectTypeSummary[]>>;
  GetChart: (fiscalYearId: number) => Promise<AxiosResponse<ProjectChart>>;
  GetMinisterChart: (fiscalYearId: number, ministerId: number) => Promise<AxiosResponse<ProjectChart>>;
  GetRegionChart: (fiscalYearId: number, regionId: number) => Promise<AxiosResponse<ProjectChart>>;
  GetProvinceChart: (fiscalYearId: number, provinceId: number) => Promise<AxiosResponse<ProjectChart>>;
}

const GetSummary = (fiscalYearId: number): Promise<AxiosResponse<ProjectSummary>> =>
  axios.Get<ProjectSummary>(`/api/fiscalyears/${fiscalYearId}/projects/summary`);

const GetMinisterSummary = (fiscalYearId: number, ministerId: number): Promise<AxiosResponse<ProjectSummary>> =>
  axios.Get<ProjectSummary>(`/api/fiscalyears/${fiscalYearId}/ministers/${ministerId}/projects/summary`);

const GetRegionSummary = (fiscalYearId: number, regionId: number): Promise<AxiosResponse<ProjectSummary>> =>
  axios.Get<ProjectSummary>(`/api/fiscalyears/${fiscalYearId}/regions/${regionId}/projects/summary`);

const GetProvinceSummary = (fiscalYearId: number, provinceId: number): Promise<AxiosResponse<ProjectSummary>> =>
  axios.Get<ProjectSummary>(`/api/fiscalyears/${fiscalYearId}/provinces/${provinceId}/projects/summary`);

const GetTypeSummary = (fiscalYearId: number): Promise<AxiosResponse<ProjectTypeSummary[]>> =>
  axios.Get<ProjectTypeSummary[]>(`/api/fiscalyears/${fiscalYearId}/projecttypes/summary`);

const GetMinisterTypeSummary = (fiscalYearId: number, ministerId: number): Promise<AxiosResponse<ProjectTypeSummary[]>> =>
  axios.Get<ProjectTypeSummary[]>(`/api/fiscalyears/${fiscalYearId}/ministers/${ministerId}/projecttypes/summary`);

const GetRegionTypeSummary = (fiscalYearId: number, regionId: number): Promise<AxiosResponse<ProjectTypeSummary[]>> =>
  axios.Get<ProjectTypeSummary[]>(`/api/fiscalyears/${fiscalYearId}/regions/${regionId}/projecttypes/summary`);

const GetProvinceTypeSummary = (fiscalYearId: number, provinceId: number): Promise<AxiosResponse<ProjectTypeSummary[]>> =>
  axios.Get<ProjectTypeSummary[]>(`/api/fiscalyears/${fiscalYearId}/provinces/${provinceId}/projecttypes/summary`);

const GetChart = (fiscalYearId: number): Promise<AxiosResponse<ProjectChart>> =>
  axios.Get<ProjectChart>(`/api/fiscalyears/${fiscalYearId}/projects/chart`);

const GetMinisterChart = (fiscalYearId: number, ministerId: number): Promise<AxiosResponse<ProjectChart>> =>
  axios.Get<ProjectChart>(`/api/fiscalyears/${fiscalYearId}/ministers/${ministerId}/projects/chart`);

const GetRegionChart = (fiscalYearId: number, regionId: number): Promise<AxiosResponse<ProjectChart>> =>
  axios.Get<ProjectChart>(`/api/fiscalyears/${fiscalYearId}/regions/${regionId}/projects/chart`);

const GetProvinceChart = (fiscalYearId: number, provinceId: number): Promise<AxiosResponse<ProjectChart>> =>
  axios.Get<ProjectChart>(`/api/fiscalyears/${fiscalYearId}/provinces/${provinceId}/projects/chart`);

export default {
  GetSummary,
  GetMinisterSummary,
  GetRegionSummary,
  GetProvinceSummary,
  GetTypeSummary,
  GetMinisterTypeSummary,
  GetRegionTypeSummary,
  GetProvinceTypeSummary,
  GetChart,
  GetMinisterChart,
  GetRegionChart,
  GetProvinceChart,
} as ProjectRegionService;
